import {gsap} from "../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class AppearingInteractiveButton extends PIXI.Container {


  constructor(width, height, enabledSprite, disabledSprite = null, callback, overridePivot = true, clickSound = "audio/clic-son.wav") {
    super();

    // this is use as a fix for buttons that were created early on in development.
    // Set this to false in your constructor if you do not want to override the pivot point when you press
    // Ignore otherwise
    this.overridePivot = overridePivot;
    // ==================================================================
    this.originalPosition = {x: 0, y: 0};
    this.originalPivot = {x: 0, y: 0};
    this.callback = callback;

    // Build sprites
    if (disabledSprite) {
      this.disabledSprite = disabledSprite;
      disabledSprite.setSize(width, height);
      disabledSprite.anchor.set(0.5, 0.5);
      this.addChild(disabledSprite);
    }
    this.enabledSprite = enabledSprite;
    enabledSprite.setSize(width, height);
    enabledSprite.anchor.set(0.5, 0.5);
    this.addChild(enabledSprite);

    // Click sound
    if (clickSound) {
      this.clickSound = new Howl({
        src: [clickSound],
        loop: false,
        autoplay: false,
      });
    }

    this.hide(0);
  }

  /**
   * Show button with scale animation
   * The button can be shown and not be clickable yet
   * @param interactive
   */
  show(interactive = true) {
    if (interactive) {
      this.enable(0);
    } else {
      this.disable(0);
    }

    this.removeAllEvents();
    this.on("pointerdown", this.onPress, this);

    gsap.killTweensOf(this.scale);
    gsap.to(this, {
      pixi: {
        scaleX: 1,
        scaleY: 1
      },
      duration: 0.25,
      ease: "back.out(1.7)",
    });
  }

  /**
   * Hide button with scale animation
   * @param duration
   */
  hide(duration = 0.25) {
    this.disableInteraction();
    this.removeAllEvents();

    gsap.killTweensOf(this.scale);
    gsap.to(this, {
      pixi: {
        scaleX: 0,
        scaleY: 0,
      },
      ease: "quad.out",
      duration: duration
    })
  }

  enable(duration = 0.25) {
    if (this.enabledSprite && this.disabledSprite) {
      gsap.killTweensOf(this.enabledSprite.alpha);
      gsap.to(this.enabledSprite, {
        pixi: {
          alpha: 1.0
        },
        ease: "quad.out",
        duration: duration
      });
    }

    this.enableInteraction();
  }

  disable(duration = 0.25) {
    if (this.enabledSprite && this.disabledSprite) {
      gsap.killTweensOf(this.enabledSprite.alpha);
      gsap.to(this.enabledSprite, {
        pixi: {
          alpha: 0.0
        },
        ease: "quad.out",
        duration: duration
      });
    }

    this.disableInteraction();
  }

  disableInteraction() {
    this.eventMode = "none";
    this.cursor = 'default';
  }

  enableInteraction() {
    this.eventMode = "static";
    this.cursor = 'pointer';
  }

  onPress(e) {
    // We need to offset the container and changed the pivot point when pressing so we can scale from center
    if (this.overridePivot) {
      this.originalPosition = {x: this.position.x, y: this.position.y};
      this.originalPivot = {x: this.pivot.x, y: this.pivot.y};
      this.pivot.set(this.width / 2, this.height / 2)
      this.position.x += this.width / 2;
      this.position.y += this.height / 2;
    }

    gsap.to(this, {
      pixi: {
        scale: 0.95
      },
      duration: 0.15,
      overwrite: "auto"
    });

    if (this.clickSound) {
      this.clickSound.play();
    }

    this.off("pointerdown", this.onPress, this);
    this.on("pointerup", this.onRelease, this);
    this.on("pointerupoutside", this.onRelease, this);
  }

  // Animate back and execute action
  onRelease() {
    gsap.to(this, {
      pixi: {
        scale: 1
      },
      ease: "back.out(4)",
      duration: 0.15,
      overwrite: "auto",
      onComplete: () => {
        if (this.overridePivot) {
          this.position = {...this.originalPosition};
          this.pivot = {...this.originalPivot};
        }
        this.on("pointerdown", this.onPress, this);

        this.callback();
      }
    });

    this.off("pointerup", this.onRelease, this);
    this.off("pointerupoutside", this.onRelease, this);
  }

  removeAllEvents() {
    this.off("pointerdown", this.onPress, this);
    this.off("pointerup", this.onRelease, this);
    this.off("pointerupoutside", this.onRelease, this);
  }

}
